import { useId } from "react";

import { cn } from "@/lib/utils";

export function DiscordIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-[33px] text-white", className)}
      fill="none"
      viewBox="0 0 71 55"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M60.105 4.898A58.55 58.55 0 0045.653.415a.22.22 0 00-.233.11 40.784 40.784 0 00-1.8 3.697c-5.456-.817-10.886-.817-16.23 0-.485-1.164-1.201-2.587-1.828-3.697a.228.228 0 00-.233-.11 58.386 58.386 0 00-14.451 4.483.207.207 0 00-.095.082C1.578 18.73-.944 32.144.293 45.39a.244.244 0 00.093.167c6.073 4.46 11.955 7.167 17.729 8.962a.23.23 0 00.249-.082 42.08 42.08 0 003.627-5.9.225.225 0 00-.123-.312 38.772 38.772 0 01-5.539-2.64.228.228 0 01-.022-.378 31.17 31.17 0 001.1-.862.22.22 0 01.23-.03c11.619 5.304 24.198 5.304 35.68 0a.219.219 0 01.233.027c.356.293.728.586 1.103.865a.228.228 0 01-.02.378 36.384 36.384 0 01-5.54 2.637.227.227 0 00-.121.315 47.249 47.249 0 003.624 5.897.225.225 0 00.249.084c5.801-1.794 11.684-4.502 17.757-8.961a.228.228 0 00.092-.164c1.48-15.315-2.48-28.618-10.497-40.412a.18.18 0 00-.093-.084zm-36.38 32.427c-3.497 0-6.38-3.211-6.38-7.156 0-3.944 2.827-7.156 6.38-7.156 3.583 0 6.438 3.24 6.382 7.156 0 3.945-2.827 7.156-6.381 7.156zm23.593 0c-3.498 0-6.38-3.211-6.38-7.156 0-3.944 2.826-7.156 6.38-7.156 3.582 0 6.437 3.24 6.38 7.156 0 3.945-2.798 7.156-6.38 7.156z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 0h71v55H0z" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FacebookIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      viewBox="0 0 1365.333 1365.333"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1365.3 682.683c0-377.017-305.633-682.65-682.65-682.65S0 305.667 0 682.684c0 340.73 249.635 623.145 575.986 674.357V880.012h-173.33V682.683h173.33V532.287c0-171.089 101.914-265.593 257.846-265.593 74.688 0 152.81 13.333 152.81 13.333v167.996h-86.08c-84.802 0-111.248 52.621-111.248 106.606v128.054h189.328l-30.266 197.329H789.314v477.028c326.35-51.212 575.985-333.626 575.985-674.357"
        fill="currentColor"
      />
    </svg>
  );
}

export function InstagramIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0c3.26 0 3.667.012 4.946.072 1.278.06 2.148.26 2.914.558a5.85 5.85 0 012.126 1.384A5.89 5.89 0 0123.37 4.14c.296.764.498 1.636.558 2.914C23.984 8.333 24 8.74 24 12s-.012 3.667-.072 4.946c-.06 1.278-.262 2.148-.558 2.914a5.86 5.86 0 01-1.384 2.126 5.897 5.897 0 01-2.126 1.384c-.764.296-1.636.498-2.914.558C15.667 23.984 15.26 24 12 24s-3.667-.012-4.946-.072c-1.278-.06-2.148-.262-2.914-.558a5.868 5.868 0 01-2.126-1.384A5.885 5.885 0 01.63 19.86c-.298-.764-.498-1.636-.558-2.914C.016 15.667 0 15.26 0 12s.012-3.667.072-4.946c.06-1.28.26-2.148.558-2.914.3-.801.773-1.527 1.384-2.126A5.876 5.876 0 014.14.63C4.906.332 5.774.132 7.054.072 8.333.016 8.74 0 12 0zm0 6a6 6 0 100 12 6 6 0 000-12zm7.8-.3a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM12 8.4a3.6 3.6 0 110 7.2 3.6 3.6 0 010-7.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MortyLogoIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[35px] w-[110px]", className)}
      viewBox="0 0 110 35"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.154.001H.293A.269.269 0 000 .248a.273.273 0 00.239.3l14.633 3.17c.251.053.43.284.424.548v26.221a.544.544 0 01-.424.548L.24 34.188a.273.273 0 00-.239.3.269.269 0 00.292.247h18.861c.293 0 .53-.245.53-.547V.548a.539.539 0 00-.53-.547z"
        fill={`url(#${id})`}
      />
      <ellipse cx="12.158" cy="18.526" fill="#fff" rx="0.579" ry="1.158" />
      <path
        d="M45.957 14.475l-4.674 8.2h-.38L36.23 14.29h-.076v12.34H32.42V8.106h4.2l4.464 8.681h.052l3.266-6.429a4.082 4.082 0 013.634-2.252h1.752v18.527h-3.727V14.475h-.105z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M59.056 12.737c-4.32 0-6.95 2.65-6.95 6.948 0 4.297 2.63 6.947 6.95 6.947 4.319 0 6.944-2.65 6.944-6.947 0-4.298-2.625-6.948-6.944-6.948zm2.84 5.894v2.108c0 1.959-1.07 3.065-2.841 3.065-1.772 0-2.848-1.106-2.848-3.065V18.63c0-1.953 1.082-3.06 2.848-3.06 1.766 0 2.841 1.107 2.841 3.06z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M70.266 23.51v-7.68h-3.109v-3.092h6.97v3.61h.181c.585-1.805 1.853-3.61 4.306-3.61h1.28v3.651h-2.869c-1.723 0-2.921.782-2.921 2.34v4.812h4.434v3.092h-11.38V23.54l3.108-.03zm14.428-.836v-6.131h-3.641v-3.607h2.365c1.166 0 1.59-.398 1.59-1.616V8.105h3.538v4.831h5.243v3.054h-5.243v7.588h5.243v3.054h-4.97c-2.796 0-4.125-1.646-4.125-3.958zM110 12.737l-6.285 14.957-.228.545c-.804 1.94-2.063 3.024-4.42 3.024H96.34v-2.966h2.308c.648 0 1.05-.21 1.248-.62a1.04 1.04 0 00.096-.261l.528-1.397-.45-1.072-5.122-12.204h4.258l2.009 5.615 1.26 3.883h.209l1.2-3.883 2.063-5.615 4.054-.006z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="19.694"
          x2="19.694"
          y1="34.724"
          y2="0.001"
        >
          <stop stopColor="#90278e" />
          <stop offset="1" stopColor="#ec297b" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function OpenNewTabIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("ml-[3px] inline size-[10px] text-white", className)}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M5.057 1.153h.077v1.3c-.712 0-.976.003-1.183.044a2.35 2.35 0 00-1.857 1.858c-.04.206-.044.47-.044 1.182v.467c0 1.168.008 1.598.115 1.928A2.35 2.35 0 003.674 9.44c.33.107.759.115 1.927.115h.467c.712 0 .976-.003 1.183-.043a2.35 2.35 0 001.858-1.858c.04-.207.043-.47.043-1.183h1.3v.077c0 .608 0 1.008-.067 1.354a3.65 3.65 0 01-2.886 2.886c-.346.067-.746.067-1.354.067h-.671c-.995 0-1.65 0-2.202-.179A3.65 3.65 0 01.929 8.334C.75 7.782.75 7.126.75 6.13V5.537 5.46c0-.608 0-1.007.067-1.354a3.65 3.65 0 012.886-2.885c.346-.068.746-.068 1.354-.068z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.233 2.453H7.228a.65.65 0 110-1.3h2.574a.65.65 0 01.65.65v2.574a.65.65 0 11-1.3 0V3.373L7.316 5.208a.65.65 0 11-.919-.92l1.836-1.835z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function TikTokIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[25px] w-[22px] text-white", className)}
      viewBox="0 0 22 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M15.497 8.11a9.82 9.82 0 005.728 1.831V5.833a5.79 5.79 0 01-1.203-.125V8.94a9.82 9.82 0 01-5.728-1.832v8.383a7.595 7.595 0 01-7.596 7.593 7.563 7.563 0 01-4.23-1.284A7.576 7.576 0 007.9 24.085c4.196 0 7.597-3.4 7.597-7.593V8.109zm1.484-4.145A5.725 5.725 0 0115.497.613V.085h-1.14a5.751 5.751 0 002.624 3.88zM5.122 18.583a3.474 3.474 0 013.82-5.413v-4.2a7.666 7.666 0 00-1.202-.069v3.269a3.474 3.474 0 00-2.618 6.413z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.296 7.11a9.82 9.82 0 005.727 1.831V5.708a5.749 5.749 0 01-3.04-1.743 5.751 5.751 0 01-2.625-3.88h-2.993v16.407a3.474 3.474 0 01-6.242 2.09 3.473 3.473 0 011.564-6.575c.367 0 .722.057 1.054.163V8.9A7.595 7.595 0 002.47 21.8a7.563 7.563 0 004.229 1.284c4.195 0 7.597-3.4 7.597-7.593V7.11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function XIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[22px] text-white", className)}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.522 6.771L15.48 0h-1.412L8.895 5.88 4.765 0H0l6.247 8.89L0 15.993h1.412l5.461-6.21 4.363 6.21H16l-6.478-9.22zM7.59 8.97l-.633-.885L1.92 1.039h2.168l4.064 5.686.633.885L14.068 15H11.9L7.589 8.97z"
        fill="#fff"
      />
    </svg>
  );
}
